// Градивните елементи на формата за фирма — секция, ред, поле, превключвател.
//
// Живеят отделно от `CompanyModal`, защото ги ползва и `NumberingSection`, а
// модалът е и без това твърде голям файл. Стилът е само Tailwind със
// семантични токени; заварените inline `style` обекти отпаднаха заедно с
// локалния R обект (виж „Кодови правила“ в CLAUDE.md).

import type { ReactNode } from "react";
import { Switch } from "antd";

export function Section({
  title,
  action,
  children,
}: {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2.5 rounded-xl border border-shade-2 bg-surface p-3.5">
      <div className="flex items-center justify-between">
        <span className="text-[10.5px] font-bold uppercase leading-[1.2] tracking-[0.11em] text-muted">
          {title}
        </span>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Row({
  children,
  narrow,
}: {
  children: ReactNode;
  narrow: boolean;
}) {
  return (
    <div
      className={`grid gap-2.5 ${narrow ? "grid-cols-1" : "grid-cols-2"}`}
    >
      {children}
    </div>
  );
}

export function Field({
  label,
  children,
  error,
  required,
  hint,
}: {
  label: string;
  children: ReactNode;
  error?: string;
  required?: boolean;
  /** Показва се само когато няма грешка — грешката бие подсказката. */
  hint?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-[5px]">
      <span className="text-[11px] font-semibold leading-[1.3] tracking-[0.02em] text-body">
        {label}
        {required ? <span className="ml-[3px] text-danger-ink">*</span> : null}
      </span>
      {children}
      {error ? (
        <span className="text-[11px] leading-[1.35] text-danger-ink">
          {error}
        </span>
      ) : hint ? (
        <span className="text-[11px] leading-[1.35] text-muted">{hint}</span>
      ) : null}
    </div>
  );
}

export function ToggleRow({
  checked,
  onChange,
  title,
  desc,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  title: string;
  desc: string;
}) {
  return (
    <label className="flex cursor-pointer items-center gap-3 py-1">
      <Switch checked={checked} onChange={onChange} />
      <span className="flex flex-col gap-0.5">
        <span className="text-[13px] font-semibold leading-[1.3] text-ink">
          {title}
        </span>
        <span className="text-[12px] leading-[1.35] text-muted">{desc}</span>
      </span>
    </label>
  );
}
